import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import client from './client'

export function useNotifications(unreadOnly = false, options = {}) {
  return useQuery({
    queryKey: ['notifications', unreadOnly],
    queryFn: () => client.get('/api/notifications', { params: unreadOnly ? { unread_only: true } : {} }).then((r) => r.data),
    refetchInterval: 60_000,
    ...options,
  })
}

export function useUnreadCount(options = {}) {
  return useQuery({
    queryKey: ['notifications-count'],
    queryFn: () => client.get('/api/notifications/unread-count').then((r) => r.data.count),
    refetchInterval: 30_000,
    ...options,
  })
}

export function useMarkRead() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id) => client.post(`/api/notifications/${id}/read`).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['notifications'] })
      qc.invalidateQueries({ queryKey: ['notifications-count'] })
    },
  })
}

export function useMarkAllRead() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => client.post('/api/notifications/read-all').then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['notifications'] })
      qc.invalidateQueries({ queryKey: ['notifications-count'] })
    },
  })
}

export function useClearNotifications() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => client.delete('/api/notifications').then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['notifications'] })
      qc.invalidateQueries({ queryKey: ['notifications-count'] })
    },
  })
}
